import {BID, DAILYLOG, MEETINGMINUTES, PROJECT, PUNCHLIST, RFI, SUBMITTAL, TASK} from "../services";
import {
  deleteFile$,
  getFileArchiveLink$,
  getFileLink$,
  getFiles$,
  postFile$,
  updateFileMetadata$
} from "../services/files";
import {networkError, uiInfo, uiSuccess} from "./ui";
import * as R from 'ramda';
import {APIError} from "../common/errors";
import {setArchivePending} from "../reducers/ui";
import {getBid} from "./bids";
import {getBidPhoto, getProjectPhoto} from "./photos";

export const API_GET_FILES_DONE = 'API_GET_FILES_DONE';
export const API_GET_SINGLE_FILE_DONE = 'API_GET_SINGLE_FILE_DONE';
export const API_UPLOAD_FILES = 'API_UPLOAD_FILE';
export const API_UPLOAD_FILES_DONE = 'API_UPLOAD_FILE_DONE';
export const API_DELETE_FILE_DONE = 'API_DELETE_FILE_DONE';
export const SET_UPLOAD_FILE_STATUS = 'SET_UPLOAD_FILE_STATUS';
export const setUploadFileStatus = ({metadata, type, id, subId, loading}) => ({type: SET_UPLOAD_FILE_STATUS, payload: {metadata, type, id, subId, loading}});

export const ADD_FILES = 'ADD_FILES';
export const addFiles = (list) => ({type: ADD_FILES, payload: list});
export const REMOVE_FILES = 'DELETE_FILES';
export const removeFiles = (list) => ({type: REMOVE_FILES, payload: list});

// const urlDecodeMetadata = R.evolve({ name: decodeURIComponent, path: decodeURIComponent });

export const getFiles = (type, id, subId) => doGetFiles({ type, id, subId });

const doGetFiles = (payload) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let { response, status } = await getFiles$({ offset: nextOffset, ...payload }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        // results = results.map(urlDecodeMetadata);
        dispatch(getFilesDone({ results }));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10049-'+error.status}));
  }
};

export const getFilesDone = (response, action) => ({ type: API_GET_FILES_DONE, payload: { response, action }});

export const deleteFile = (type, id, subId, fileId) => doDeleteFile({ type, id, subId, fileId });

const doDeleteFile = (payload) => async (dispatch, getState) => {
  try {
    // dispatch(uiInfo('Deleting file'));
    let { response, status } = await deleteFile$(payload).toPromise();
    dispatch(getDeleteFileDone(payload.fileId));
    dispatch(uiSuccess('File deleted'));
  } catch (error) {
    dispatch(networkError({...error, number: '10050-'+error.status}));
  }
};

export const getDeleteFileDone = (fileId) => ({ type: API_DELETE_FILE_DONE, payload: { fileId }});

export const getProjectSingleFile = (id, fileId) => doGetSingleFile({ type: PROJECT, id: id, fileId });
export const getBidSingleFile = (id, fileId) => doGetSingleFile({ type: BID, id: id, fileId });
export const getPunchlistSingleFile = (project, id, fileId) => doGetSingleFile({ type: PUNCHLIST, id: project, subId: id, fileId });
export const getRfiSingleFile = (project, id, fileId) => doGetSingleFile({ type: RFI, id: project, subId: id, fileId });
export const getSubmittalSingleFile = (project, id, fileId) => doGetSingleFile({ type: SUBMITTAL, id: project, subId: id, fileId });
export const getTaskSingleFile = (project, id, fileId) => doGetSingleFile({ type: TASK, id: project, subId: id, fileId });
export const getDailyLogSingleFile = (project, id, fileId) => doGetSingleFile({ type: DAILYLOG, id: project, subId: id, fileId });
export const getMeetingMinutesSingleFile = (project, id, fileId) => doGetSingleFile({ type: MEETINGMINUTES, id: project, subId: id, fileId });

const doGetSingleFile = (payload) => async (dispatch, getState) => {
  try {
    let { response, status } = await getFileLink$(payload).toPromise();
    // response = urlDecodeMetadata(response);
    dispatch(getSingleFileDone(response));
  } catch (error) {
    dispatch(networkError({...error, number: '10051-'+error.status}));
  }
};

export const getSingleFileDone = (response) => ({ type: API_GET_SINGLE_FILE_DONE, payload: { response }});

export const getFileLink = (type, id, subId, fileId) => doGetFileLink({ type, id, subId, fileId });

const doGetFileLink = (payload) => async (dispatch, getState) => {
  try {
    let {response, status} = await getFileLink$(payload).toPromise();
    window.open(response.url, '_blank');
  } catch (error) {
    dispatch(networkError({...error, number: '10052-'+error.status}));
  }
};

export const getFileArchiveLink = (type, id, subId) => doGetFileArchiveLink({ type, id, subId });

const doGetFileArchiveLink = (payload) => async (dispatch, getState) => {
  const { id, subId } = payload;
  const docId = subId || id;
  dispatch(setArchivePending(docId, { state: 'pending' }));
  try {
    let { response, status } = await getFileArchiveLink$(payload).toPromise();
  } catch (error) {
    dispatch(networkError({...error, number: '10053-'+error.status}));
  }
};

// const encodePath = string => encodeURI(string).replace(/%25/g, '%');
// const encodeName = string => encodeURIComponent(string).replace(/~/g, '%7E');

const embedFileMetadata = (path, files) => {
  files = files || [];
  path = path || '/';
  return files.map(file => ({
    metadata: {
      path: path,
      name: file.name,
      // mimetype: file.type
    },
    file: file,
    onSuccess: file.onSuccess
  }));
};

const embedFolderMetadata = (path, name) => {
  path = path || '/';
  return [
    {
      metadata: {
        path: path,
        name: name,
        mimetype: 'application/x-directory',
      }
    }
  ];
};

const doUploadFile = (payload) => async (dispatch, getState) => {
  try {
    let { files, type, id, subId } = payload;
    for (let fileData of files) {
      try {
        let { metadata, file, onSuccess } = fileData;
        dispatch(uiInfo('Uploading file'));
        dispatch(setUploadFileStatus({metadata, type, id, subId, loading: true}));
        let { response, status } = await postFile$({ type, id, subId, metadata, file }).toPromise();
        if (onSuccess) onSuccess();
        let fileId = response;
        switch (type) {
          case PROJECT:
            dispatch(getProjectSingleFile(id, fileId));
            break;
          case BID:
            dispatch(getBidSingleFile(id, fileId));
            break;
          case SUBMITTAL:
            dispatch(getSubmittalSingleFile(id, subId, fileId));
            break;
          case PUNCHLIST:
            dispatch(getPunchlistSingleFile(id, subId, fileId));
            break;
          case DAILYLOG:
            dispatch(getDailyLogSingleFile(id, subId, fileId));
            break;
          case MEETINGMINUTES:
            dispatch(getMeetingMinutesSingleFile(id, subId, fileId));
            break;
          case TASK:
            dispatch(getTaskSingleFile(id, subId, fileId));
            break;
          case RFI:
            dispatch(getRfiSingleFile(id, subId, fileId));
            break;
          default:
            dispatch(networkError(new APIError("cannot construct refresh action; invalid document type")));
        }
        dispatch(setUploadFileStatus({metadata, type, id, subId, loading: false}));
        dispatch(uiSuccess('File upload successful'));
      } catch (error) {
        dispatch(networkError({...error, number: '10054-'+error.status}));
      }
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10055-'+error.status}));
  }
};

export const createFolder = (type, id, subId, path, name) =>
  doUploadFile({
    type,
    id,
    subId,
    files: embedFolderMetadata(path, name)
  });

export const uploadFiles = (type, id, subId, path, files) =>
  doUploadFile({
    type,
    id,
    subId,
    files: embedFileMetadata(path, files)
  });

export const renameFile = (type, id, subId, fileId, name) => async (dispatch, getState) => {
  try {
    await updateFileMetadata$({ type, id, subId, fileId, metadata: { name } }).toPromise();
    dispatch(doGetSingleFile({ type, id, subId, fileId }));
  } catch (error) {
    dispatch(networkError({...error, number: '10143-'+error.status}))
  }
};

export const uploadFilesDone = (response, action) => ({ type: API_UPLOAD_FILES_DONE, payload: { response, action }});

export const setFileIsAddendum = (type, id, subId, fileId, isAddendum) => async (dispatch, getState) => {
  try {
    await updateFileMetadata$({ type, id, subId, fileId, metadata: { isaddendum: isAddendum } }).toPromise();
    dispatch(doGetSingleFile({ type, id, subId, fileId }));
    dispatch(getBid(id));
  } catch (error) {
    dispatch(networkError({...error, number: '10056-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/files.js